import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory
} from "react-router-dom";
import './App.css';
import Home from './Home'
import TopNav from './TopNav'
import BottomNav from './BottomNav'
import FindCompany from './FindCompany'
import CompanyBadges from './CompanyBadges'
import Checkout from './Checkout'
import ThankYou from './ThankYou'

function App() {

  const selection = [];
  const [list, setList] = React.useState(selection);

   return (

    <Router>
      <div class="container">
        {/*
          A <Switch> looks through all its children <Route>
          elements and renders the first one whose path
          matches the current URL. Use a <Switch> any time
          you have multiple routes, but you want only one
          of them to render at a time
        */}
        <Switch>
          <Route exact path="/">
            <Home />
            <BottomNav />
          </Route>
          <Route path="/find">
            <TopNav/>
            <FindCompany />
            <BottomNav />
          </Route>
          <Route path="/company">
            <TopNav/>
            <CompanyBadges list={list} setList={setList} />
            <BottomNav />
          </Route>
          <Route path="/checkout">
            <TopNav/>
            <Checkout list={list} />
            <BottomNav />
          </Route>
          <Route path="/thankyou">
            <TopNav/>
            <ThankYou />
            <BottomNav />
          </Route>
          <Route path="/s">
            <div>6</div>
          </Route>
          <Route path="/company/{id}/support">
            <div>7</div>
          </Route>
        </Switch>        
      </div>
    </Router>

  );
}

export default App;
